import React, { useEffect, MouseEventHandler, ReactNode } from "react";
import { isEmpty, isNil } from "ramda";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import useUserAccess from "../../effects/useUserAccess";
import { get } from "lodash";

interface Props {
  entity?: string;
  heading: string;
  primaryButtonText?: string;
  primaryButtonClickHandler?: MouseEventHandler;
  secondaryButtonText?: string;
  secondaryButtonClickHandler?: MouseEventHandler;
  tertiaryButtonText?: string;
  tertiaryButtonClickHandler?: MouseEventHandler;
  children?: ReactNode;
}

const PageHeading: React.FC<Props> = (props) => {
  const {
    entity,
    heading,
    primaryButtonText,
    primaryButtonClickHandler,
    secondaryButtonText,
    secondaryButtonClickHandler,
    tertiaryButtonText,
    tertiaryButtonClickHandler,
  } = props;
  const access = useUserAccess();
  let isCreateAllowed = get(access, `${entity}.Access.C`);
  if (typeof entity === "string" &&  entity.includes('|')) {
    let listEntity = entity.split('|');
    isCreateAllowed = listEntity.some(key => get(access, `${key}.Access.C`));
  }

  return (
    <Box display="flex" p={1} alignItems="center">
      <Box flex={1} px={2}>
        <h1>{heading}</h1>
      </Box>
      {props.children}
      {!isNil(tertiaryButtonText) && !isNil(tertiaryButtonClickHandler) && (
        <Box pr={2}>
          <Button
            variant="contained"
            color="primary"
            size="medium"
            onClick={tertiaryButtonClickHandler}
          >
            {tertiaryButtonText}
          </Button>
        </Box>
      )}
      {!isNil(secondaryButtonText) && !isNil(secondaryButtonClickHandler) && (
        <Box pr={2}>
          <Button
            variant="contained"
            color="primary"
            size="medium"
            onClick={secondaryButtonClickHandler}
          >
            {secondaryButtonText}
          </Button>
        </Box>
      )}
      {!isNil(primaryButtonText) &&
        !isNil(primaryButtonClickHandler) &&
        isCreateAllowed && (
          <Box pr={2}>
            <Button
              variant="contained"
              color="primary"
              size="medium"
              onClick={primaryButtonClickHandler}
            >
              {primaryButtonText}
            </Button>
          </Box>
        )}
    </Box>
  );
};

export default PageHeading;
